import { render, staticRenderFns } from "./AutoManufactureModal.vue?vue&type=template&id=1f3d992b&scoped=true&"
import script from "./AutoManufactureModal.vue?vue&type=script&lang=js&"
export * from "./AutoManufactureModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3d992b",
  null
  
)

export default component.exports